module.exports = __webpack_public_path__ + "static/media/015ty@4x.4e71bf80.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/015ty@4x.png
// module id = 419
// module chunks = 0 1